import contentService from '../../services/contentService';
import {
  FETCH_ARTICLE_BY_ID_FAILURE,
  FETCH_ARTICLE_BY_ID_REQUEST,
  FETCH_ARTICLE_BY_ID_SUCCESS,
  FETCH_ARTICLE_CLEAN_UP,
} from '../constants/articleTypes';
import { DEFAULT_LOCALE } from '../../i18n';

const fetchArticleRequest = () => {
  return {
    type: FETCH_ARTICLE_BY_ID_REQUEST,
  };
};

const fetchArticleSuccess = (article) => {
  return {
    type: FETCH_ARTICLE_BY_ID_SUCCESS,
    payload: article,
  };
};

const fetchArticleFailure = (error) => {
  return {
    type: FETCH_ARTICLE_BY_ID_FAILURE,
    payload: error,
  };
};

export const fetchArticleCleanUp = () => {
  return {
    type: FETCH_ARTICLE_CLEAN_UP,
  };
};

export const fetchArticle = (slug, locale = DEFAULT_LOCALE) => {
  return async (dispatch) => {
    dispatch(fetchArticleRequest());
    try {
      const article = await contentService.getContentBySlug(slug, locale, {
        'populate[main_image]': true,
        'populate[profile]': true,
      });

      if (article) {
        dispatch(fetchArticleSuccess(article));
      } else {
        dispatch(fetchArticleFailure('Article not found'));
      }
    } catch (error) {
      dispatch(fetchArticleFailure(error.message));
    }
  };
};
